import { Text } from '@chakra-ui/react';

function TcapCopyRight() {
    return (
        <Text
            color="gray.600"
            fontSize="xs"
            fontWeight="semibold"
            letterSpacing="widest"
            textTransform="uppercase"
            textAlign="center">
            © {new Date().getFullYear()} TCAP. All rights reserved.
        </Text>
    );
}

export { TcapCopyRight };
